module.exports = __webpack_public_path__ + "static/img/bg_Overview.8c9caadf.png";